package com.nonopn.skydome.common.app.pages.certnsg

import com.nonopn.skydome.common.app.pages.interpretation.InterpretationEngine
import com.nonopn.skydome.common.app.utils.fmt

/**
 * Modèle de données pour le certificat Nsg — Strike Radar Phase 3.
 *
 * Calcule automatiquement les textes d'interprétation multi-langue
 * (FR / EN / ES / PT) pour la densité de foudroiement annuelle.
 *
 * Normes : IEC 62858:2019 · IEC 62305-2:2024 · Réseau GLD360+
 *
 * Terminologie : Nsg (pas Ng) — IEC 62858:2019
 *
 * @param siteName    Nom du site
 * @param nsg12Months Densité de foudroiement annuelle (coups/km²/an)
 * @param nsgUnit     Unité d'affichage (défaut : "impacts/km²/an")
 * @param lang        Code langue ISO 639-1 ("fr", "en", "es", "pt"). Défaut : "fr"
 */
data class CertNsgModel(
    val siteName: String,
    val nsg12Months: Double,
    val nsgUnit: String = "impacts/km²/an",
    val lang: String = "fr"
) {
    /** Nsg value formatted with 2 decimal places. */
    val nsgFormatted: String
        get() = nsg12Months.fmt(2)

    // ── Interpretation texts ─────────────────────────────────────────────────────

    /** Nsg level interpretation per IEC 62858:2019 / IEC 62305-2:2024. */
    val interpretationNsg: String
        get() = InterpretationEngine.interpret(
            key = "nsg_level",
            lang = lang,
            level = InterpretationEngine.nsgLevel(nsg12Months),
            placeholders = mapOf("nsg" to nsgFormatted)
        )

    /** Normative conclusion of the Nsg certificate. */
    val interpretationConclusion: String
        get() = InterpretationEngine.interpret(
            key = "nsg_conclusion",
            lang = lang
        )
}
